import CvSelect from './CvSelect.vue';
export { CvSelect };
export default CvSelect;
